import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaCalendar } from "@/components/agenda/agenda-calendar";

export const Route = createFileRoute("/agenda/agendamentos")({
  component: () => (
    <AgendaShell>
      <AgendaCalendar />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Agendamentos — Agenda — GPS Drive" }] }),
});
